module.exports = __webpack_public_path__ + "media/images/sport--eiskunstlauf-83f8b97f34eb98b87507d7d96f2463a3.png";